module.exports = __webpack_public_path__ + "img/fuwuzhongxin3.93858a28.png";